<template>
  <div class="page-letter">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="letter_box">
        <!-- <img src="../../assets/logo.png" class="logo"> -->
        <img src="../../assets/gift_btn.png" class="gift_btn" @click="toGift">
        <div class="letter" :style="{backgroundImage:'url(' + cardInfo.card_image + ')'}" v-if="cardInfo">
          <img :src="cardInfo.paste_image" class="tiezhi">
          <div class="userInfo">
            <img :src="cardInfo.avatar" class="head_img">
            {{cardInfo.nickname}}
          </div>
          <div class="write_text">{{cardInfo.message}}</div>
        </div>
        <img :src="btnImg" class="want_btn" @click="toHome" v-if="cardInfo">
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'page-letter',
  data () {
    return {
      cardInfo: null,
      btnImg: require('../../assets/want.png')
    }
  },
  async created () {
    // this.preLoad()
  },
  async mounted () {
    await this.getBless()
    await this.setWxShare()
    // await this.initBScroll()
    // this.$stat({ event: 'loading_page' }) // 上报事件
  },
  methods: {
    async getBless () {
      this.$toast.setDefaultOptions('loading', { duration: 0 })
      this.$toast.loading('加载中')
      const id = this.$store.state.shareId
      try {
        const res = await this.$fetch.get('/blessing-card/read-blessing', { message_id: id })
        // console.log(res)
        this.cardInfo = res.data
        console.log('关于id', this.$store.state.actInfo.user_id, this.cardInfo.user_id)
        if (this.$store.state.actInfo.user_id === this.cardInfo.user_id) {
          this.btnImg = require('../../assets/again_write.png')
        } else {
          this.btnImg = require('../../assets/want.png')
        }
        this.$toast.clear()
        console.log(this.cardInfo)
      } catch (error) {
        this.$toast.clear()
        Toast('获取卡片信息失败')
        console.log('error', error)
      }
    },
    toGift () {
      this.$router.push({ path: '/rule' })
    },
    tabChange (id) {
      if (id === 1) {
        this.nowTab = 1
        this.nowTab_bg = require('../../assets/card_tab1.png')
      } else {
        this.nowTab = 2
        this.nowTab_bg = require('../../assets/card_tab2.png')
      }
    },
    toHome () {
      if (this.$store.state.actInfo.user_id === this.cardInfo.user_id) {
        this.$stat({ event: 'again_game' }) // 上报事件
      } else {
        this.$stat({ event: 'want' }) // 上报事件
      }
      this.$router.push({ path: '/home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-letter{
  height: 100vh;
}
.letter_box{
  position: relative;
  width: 100%;
  height: auto;
  min-height: 100vh;
  background: url('../../assets/share_bg.png') 100% top no-repeat, linear-gradient(to bottom,#91b9f3, #c2daf9);
  background-size: 100%;
  padding-top: 146px;
  padding-bottom: 30px;
  box-sizing: border-box;
  .logo{
    position: absolute;
    width: 241px;
    height: auto;
    left: 37px;
    top: 35px;
  }
  .gift_btn{
    width: 86px;
    height: auto;
    position: absolute;
    top: 40px;
    right: 150px;
  }
  .letter{
    position: relative;
    display: block;
    margin:auto;
    width: 696px;
    height: 474px;
    // background:url('../../assets/card1.png') no-repeat;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .tiezhi{
      position: absolute;
      width: 144px;
      height: 106px;
      top: 56px;
      right: 63px;
    }
    .userInfo{
      position: absolute;
      top: 77px;
      left: 74px;
      height: 72px;
      width: auto;
      max-width: 320px;
      font-size: 24px;
      color: #333;
      // line-height: 72px;
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      .head_img{
        width: 72px;
        height: 72px;
        border-radius: 50%;
        margin-right: 13px;
        vertical-align:middle;
      }
    }
    .write_text{
      position: absolute;
      top: 185px;
      left: 94px;
      width: 508px;
      color: #9A5300;
      font-size: 28px;
      line-height: 56px;
    }
  }
  .want_btn{
    display: block;
    margin:auto;
    width: 337px;
    height: 145px;
  }
}
</style>
